import React from 'react'
import { ThemeProvider } from '@fluentui/react'

import './App.css'

import AppRouter from 'AppRouter'
import primaryTheme from 'themes/primary'
import { MsalProvider } from "@azure/msal-react";
import { useMsalInstance } from "./store/MsalContextProvider";

function App() {
  const context = useMsalInstance();
  if (!context.initialized) return null;
  return (
    <MsalProvider instance={context.instance}>
      <ThemeProvider applyTo="body" theme={primaryTheme}>
          <AppRouter />
      </ThemeProvider>
    </MsalProvider>
  )
}

export default App
